import { render } from "./Help.vue?vue&type=template&id=1326bae0&scoped=true&bindings={}"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=1326bae0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1326bae0"

export default script